enum FormaGeneraSolicitudEnum {
    Automatica = "A",
    Manual = "M"
}

export default FormaGeneraSolicitudEnum;